export default __webpack_public_path__ + "static/dignity-logo-2bcdb39c0a565afd21b582aedc87600f.png";